import "@/App.css";
import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "./components/site/Navbar";
import Hero from "./components/site/Hero";
import Marquee from "./components/site/Marquee";
import Showcase from "./components/site/Showcase";
import HowItWorks from "./components/site/HowItWorks";
import Features from "./components/site/Features";
import Privacy from "./components/site/Privacy";
import DownloadCTA from "./components/site/DownloadCTA";
import ContactSection from "./components/site/ContactSection";
import Footer from "./components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    window.__lenis = lenis;
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App">
      <Toaster position="bottom-right" richColors />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Showcase />
        <HowItWorks />
        <Features />
        <Privacy />
        <DownloadCTA />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
